import { Ordrebekreftelse, ProduktSpesifikasjon } from "codegen";
import { Link } from "react-router-dom";

import { Direction, Flex } from "@ntemarked/mittne-components/dist/Flex/Flex";

import { FormElementError } from "components/organisms/form/Form";
import { SelectFieldClean } from "components/organisms/form/SelectField";
import { TextFieldClean } from "components/organisms/form/TextField";
import { noneOrderConfirmation } from "pages/Productadmin/ProductsPage";

export function ProductPageOrderConfirmation({
	selectedOrderConfirmation,
	setSelectedOrderConfirmation,
	orderConfirmations,
	formErrors,
	product,
}: Readonly<{
	selectedOrderConfirmation: Ordrebekreftelse | undefined;
	setSelectedOrderConfirmation: (OrderConfirmation: Ordrebekreftelse | undefined) => void;
	orderConfirmations: Ordrebekreftelse[];
	formErrors: FormElementError<unknown>;
	product: ProduktSpesifikasjon;
}>) {
	return (
		<Flex direction={Direction.column} gap="1rem">
			<h2>Ordrebekreftelse</h2>
			<h3>Informasjonen her blir brukt av ordrebekreftelse</h3>
			{!!orderConfirmations?.length && (
				<>
					<div>
						<SelectFieldClean
							value={selectedOrderConfirmation?.id || ""}
							label="Ordrebekreftelse"
							required={true}
							name="orderConfirmation"
							onChange={(value) => {
								if (value === noneOrderConfirmation.id) {
									setSelectedOrderConfirmation(noneOrderConfirmation);
								} else {
									const selected = orderConfirmations.find((c) => c.id === value);
									setSelectedOrderConfirmation(selected);
								}
							}}
							options={
								orderConfirmations
									?.map((g) => ({
										value: g.id ?? "",
										label: g.navn ?? "",
										disabled: false,
										hidden: false,
									}))
									.concat([
										{ value: noneOrderConfirmation.id ?? "", label: noneOrderConfirmation.navn ?? "", disabled: false, hidden: false },
										{
											value: "",
											label: "Velg ordrebekreftelse",
											disabled: true,
											hidden: true,
										},
									]) || []
							}
							formErrors={formErrors}
						/>
						{selectedOrderConfirmation?.id && selectedOrderConfirmation?.id !== noneOrderConfirmation.id && (
							<Link
								to={`/products/order-confirmations/${selectedOrderConfirmation.id}${product.tariffId ? `?tariffId=${product.tariffId}` : ""}`}
								target="_blank"
							>
								Se ordrebekreftelse
							</Link>
						)}
					</div>

					{selectedOrderConfirmation?.prising?.map((pris, i) => (
						<TextFieldClean
							key={i}
							index={i}
							required={true}
							name="prices[]"
							label={pris.tittel}
							defaultValue={product.priselementer?.find((prisElement) => prisElement.prisTypeId === pris.prisTypeId)?.gjeldendePris}
							placeholder="00 kr/øre"
							formErrors={formErrors}
						/>
					)) ?? <></>}
				</>
			)}
		</Flex>
	);
}
